"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shareLinks = void 0;
exports.shareLinks = {
    facebook: {
        icon: `facebook`,
        apiLink: 'https://facebook.com/sharer.php',
        utm_medium: `share-button-facebook`,
    },
    twitter: {
        icon: `twitter`,
        apiLink: `https://twitter.com/intent/tweet`,
        utm_medium: `share-button-twitter`,
    },
    whatsapp: {
        icon: `whatsapp`,
        apiLink: `https://api.whatsapp.com/`,
        utm_medium: `share-button-whatsapp`,
    },
    mail: {
        icon: `mail`,
        apiLink: 'mailto:',
        utm_medium: `share-button-mail`,
    },
};
//# sourceMappingURL=ShareForm.constants.js.map